<template>
  <div v-if="categoryDescription && categoryDescription.length">
    <div
      v-for="(description, i) in categoryDescription"
      :key="'category-description-' + i"
      class="categoryDescription"
      v-html="description"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('entryForm', ['categoryDescription'])
  }
};
</script>
